import { render, staticRenderFns } from "./HealthLife.vue?vue&type=template&id=47db646c&scoped=true"
import script from "./HealthLife.vue?vue&type=script&lang=js"
export * from "./HealthLife.vue?vue&type=script&lang=js"
import style0 from "./HealthLife.vue?vue&type=style&index=0&id=47db646c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47db646c",
  null
  
)

export default component.exports